import PropTypes from 'prop-types';

export const LocationType = Object.freeze({
    ACCOMMODATION: 'ACCOMMODATION',
    AIRPORT: 'AIRPORT',
    CITY: 'CITY',
    COUNTRY: 'COUNTRY',
    IATA_CODE: 'IATA_CODE',
    NEAREST: 'NEAREST',
    REGION: 'REGION',
    CONTINENT: 'CONTINENT',
    STATE: 'STATE',
    MULTI_CITY: 'MULTI_CITY',
    NEIGHBORHOOD: 'NEIGHBORHOOD',
    LANDMARK: 'LANDMARK',
    OTHERS: 'OTHERS',
    HOTEL: 'HOTEL',
    MINOR_AIRPORT: 'MINOR_AIRPORT',
    BUS_STATION: 'BUS_STATION',
    TRAIN_STATION: 'TRAIN_STATION',
    METRO_STATION: 'METRO_STATION',
    POINT_OF_INTEREST: 'POINT_OF_INTEREST',
    MULTI_CITY_VICINITY: 'MULTI_CITY_VICINITY',
    HIGH_LEVEL_REGION: 'HIGH_LEVEL_REGION',
    PROVINCE_STATE: 'PROVINCE_STATE',
});

export const LocationProductType = Object.freeze({
    FLIGHT: 'FLIGHT',
    DP: 'DP',
    HOTEL: 'HOTEL',
    TRAIN: 'TRAIN',
});

export const GeoType = Object.freeze({
    ACCOMMODATION: 'ACCOMMODATION',
    REGION: 'REGION',
    GOOGLE_PLACE: 'GOOGLE_PLACE',
});

export const LocationUserSubscription = Object.freeze({
    NON_PRIME: 'NON_PRIME',
    PRIME: 'PRIME',
});

export const LocationHotelsSuppliers = Object.freeze({
    HSA: 'HSA'
});

export const GeoNodeType = Object.freeze({
    CITY: 'CITY',
    AIRPORT: 'AIRPORT',
});

export const LocationProp = PropTypes.shape({
    countryCode: PropTypes.string.isRequired,
    geoNodeId: PropTypes.number,
    geoNodeIdSupplier: PropTypes.string,
    geoNodeType: PropTypes.oneOf(Object.values(GeoNodeType)),
    iata: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.oneOf(Object.values(LocationType)).isRequired,
    regionType: PropTypes.oneOf(Object.values(LocationType)),
});
